import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import AntIcon from 'antd/lib/icon';
import './style';

function Icon({
  children, className, size, type, spin, ...rest
}) {
  const computedClassName = classNames(
    'bsa-icon',
    {
      'icon-sm': size === 'small',
      'icon-lg': size === 'large',
      'icon-xl': size === 'xlarge',
    },
    className,
    { anticon: type === 'mdi' },
    { 'anticon-mdi': type === 'mdi' },
    { 'anticon-spin': type === 'mdi' && spin },
  );

  return type === 'mdi' ? (
    <i className={computedClassName} {...rest}>
      {children}
    </i>
  ) : (
    <AntIcon className={computedClassName} type={type} spin={spin} {...rest}>
      {children}
    </AntIcon>
  );
}

Icon.propTypes = {
  ...AntIcon.propTypes,
  size: PropTypes.oneOf(['small', 'default', 'large', 'xlarge']),
};

Icon.defaultProps = {
  ...AntIcon.defaultProps,
  size: 'default',
};

export default Icon;
